import React from 'react';
import { useHistory } from 'react-router';
import { useGlobalContext } from 'seagull';
import { routes } from "../../../constants";
import IntegrationCard from "../IntegrationCard/IntegrationCard";
import { useStoreActions } from "../../../store/store-context";
import APIKeyModal from "../APIKeyModal/APIKeyModal";
import karbonLogoUrl from "./karbon-logo.png";
import { IntegrationSource } from "../../../types/api.model";
import { CardHandler } from "../APIKeyPM/APIKeyPM.utils";
const KarbonCard = _ref => {
  let {
    integration
  } = _ref;
  const history = useHistory();
  const globalContext = useGlobalContext();
  const {
    api,
    fetchIntegrations
  } = useStoreActions();
  const ui = {
    goToPage: page => history.push(page),
    requestApiKey: apiKeyListener => globalContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        return /*#__PURE__*/React.createElement(APIKeyModal, {
          pmName: IntegrationSource.Karbon,
          dismissModal: dismissModal,
          apiKeyListener: apiKeyListener
        });
      }
    }),
    refetchIntegrations: async () => fetchIntegrations()
  };
  const server = {
    saveApiKey: async apiKey => api.karbon.setAPIKey(apiKey)
  };
  const karbonCardHandler = new CardHandler(ui, integration, server);
  return /*#__PURE__*/React.createElement(IntegrationCard, {
    "data-testid": "karbon-card",
    title: "Karbon",
    subTitle: "Connect your account to boost teamwork and streamline processes",
    mainAction: /*#__PURE__*/React.createElement(IntegrationCard.MainActionButton, {
      "data-testid": "karbon-card-connect",
      onClick: () => karbonCardHandler.handleClick(routes.karbonSetup)
    }, karbonCardHandler.getActionText()),
    icon: /*#__PURE__*/React.createElement(IntegrationCard.LogoImg, {
      alt: "karbon logo",
      src: karbonLogoUrl
    })
  });
};
export default KarbonCard;